import dashboard from './dashboard'
import cache from './cache'

// Array of sections
export default [...dashboard, ...cache]
